import { render, staticRenderFns } from "./JobTypesTable.vue?vue&type=template&id=1165ba19&"
import script from "./JobTypesTable.vue?vue&type=script&lang=js&"
export * from "./JobTypesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports